const actions = {
  CREATE_PAYMENT_ITEM: 'CREATE_PAYMENT_ITEM',
  CREATE_PAYMENT_ITEM_ENDED: 'CREATE_PAYMENT_ITEM_ENDED',
  UPDATE_PAYMENT_ITEM: 'UPDATE_PAYMENT_ITEM',
  UPDATE_PAYMENT_ITEM_ENDED: 'UPDATE_PAYMENT_ITEM_ENDED',
  SEARCH_PAYMENT_ITEMS: 'SEARCH_PAYMENT_ITEMS',
  SEARCH_PAYMENT_ITEMS_ENDED: 'SEARCH_PAYMENT_ITEMS_ENDED',
  CREATE_PAYMENT_SERVICE: 'CREATE_PAYMENT_SERVICE',
  CREATE_PAYMENT_SERVICE_ENDED: 'CREATE_PAYMENT_SERVICE_ENDED',
  UPDATE_PAYMENT_SERVICE: 'UPDATE_PAYMENT_SERVICE',
  UPDATE_PAYMENT_SERVICE_ENDED: 'UPDATE_PAYMENT_SERVICE_ENDED',
  FIND_PAYMENT_SERVICE: 'FIND_PAYMENT_SERVICE',
  FIND_PAYMENT_SERVICE_ENDED: 'FIND_PAYMENT_SERVICE_ENDED',
  SEARCH_PAYMENT_SERVICES: 'SEARCH_PAYMENT_SERVICES',
  SEARCH_PAYMENT_SERVICES_ENDED: 'SEARCH_PAYMENT_SERVICES_ENDED',
  REDEEM_PAYMENT: 'REDEEM_PAYMENT',
  REDEEM_PAYMENT_ENDED: 'REDEEM_PAYMENT_ENDED',
  REFUND_PAYMENT: 'REFUND_PAYMENT',
  REFUND_PAYMENT_ENDED: 'REFUND_PAYMENT_ENDED',
  SEARCH_PAYMENT_TRADE_RECORD: 'SEARCH_PAYMENT_TRADE_RECORD',
  SEARCH_PAYMENT_TRADE_RECORD_ENDED: 'SEARCH_PAYMENT_TRADE_RECORD_ENDED',
  SEARCH_PAYMENT_REDEEM_RECORD: 'SEARCH_PAYMENT_REDEEM_RECORD',
  SEARCH_PAYMENT_REDEEM_RECORD_ENDED: 'SEARCH_PAYMENT_REDEEM_RECORD_ENDED',
  FIND_PAYMENT: 'FIND_PAYMENT',
  FIND_PAYMENT_ENDED: 'FIND_PAYMENT_ENDED',
  SEARCH_PAYMENTS: 'SEARCH_PAYMENTS',
  SEARCH_PAYMENTS_ENDED: 'SEARCH_PAYMENTS_ENDED',
  CREATE_FAKE_PAYMENT: 'CREATE_FAKE_PAYMENT',
  CREATE_FAKE_PAYMENT_ENDED: 'CREATE_FAKE_PAYMENT_ENDED',
  SEARCH_PAYMENT_SERVICE_STORE_FIELDS: 'SEARCH_PAYMENT_SERVICE_STORE_FIELDS',
  SEARCH_PAYMENT_SERVICE_STORE_FIELDS_ENDED: 'SEARCH_PAYMENT_SERVICE_STORE_FIELDS_ENDED',
  UPDATE_PAYMENT_SERVICE_STORE_FIELDS: 'UPDATE_PAYMENT_SERVICE_STORE_FIELDS',
  UPDATE_PAYMENT_SERVICE_STORE_FIELDS_ENDED: 'UPDATE_PAYMENT_SERVICE_STORE_FIELDS_ENDED',
  MANUALLY_REFUND_PAYMENT: 'MANUALLY_REFUND_PAYMENT',
  MANUALLY_REFUND_PAYMENT_ENDED: 'MANUALLY_REFUND_PAYMENT_ENDED',
  REJECT_REFUND_PAYMENT: 'REJECT_REFUND_PAYMENT',
  REJECT_REFUND_PAYMENT_ENDED: 'REJECT_REFUND_PAYMENT_ENDED',
  UPDATE_PAYMENT_DETAIL_WITH_THIRD_PARTY: 'UPDATE_PAYMENT_DETAIL_WITH_THIRD_PARTY',
  UPDATE_PAYMENT_DETAIL_WITH_THIRD_PARTY_ENDED: 'UPDATE_PAYMENT_DETAIL_WITH_THIRD_PARTY_ENDED',
};

export default actions;
